/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      const $enrolledVariantsElement = document.querySelector("#enrolled-variants");
      if ($enrolledVariantsElement) {
        const enrolledVariantsList = JSON.parse($enrolledVariantsElement.innerHTML)?.["sku_list"].split(",");
        if (enrolledVariantsList.includes(variant.sku)) {
          setTimeout(() => {
            document.querySelectorAll(".product__media.flickity-cell.is-selected").forEach(element => {
              element.querySelector(`.lazy-image.mobile-zoom-wrapper`).classList.add("available-bwp");
            })
          }, 100) 
        } else {
          setTimeout(() => {
            document.querySelectorAll(".product__media.flickity-cell.is-selected").forEach(element => {
              element.querySelector(`.lazy-image.mobile-zoom-wrapper`).classList.remove("available-bwp");
            })
          },100)

        }
      }
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/
/*
* Variant image for color swatches
*/
(function(){

    function init(colorName, product, container){
        //image height and width
        const height = 42;
        const width = 42;
        console.log("colorName",colorName)
        const colorSelector = container.querySelector(`[data-select-label="${colorName}" i]`);        
        console.log("colorSelector",`[data-select-label="${colorName}" i]`)
        if(colorSelector){
        
            const position = colorSelector.getAttribute('data-option-position');
            const index = parseInt(position, 10);

            //get color values
            const colorValues = Array.prototype.map.call(colorSelector.querySelectorAll('input'), obj => {
               return obj;
            })
        
            //check variants with featured media to find option that matches the Colour option value
            for (let i=0; i<product.variants.length; i++) {
                const variant = product.variants[i];
                
                if( variant.featured_media && variant.featured_media.preview_image ){
                
                    let value = variant.option1;
                    if(index === 2){
                       value = variant.option2;
                    }
                    if(index === 3){
                       value = variant.option3;
                    }            
                    
                    const foundMatch = colorValues.filter(function(elem){
                        return elem.value == value;
                    });
                    
                    
                    if(foundMatch.length){
                    
                        const label = foundMatch[0].parentElement.querySelector('label');
                        //const size = `${width}x${height}_crop_center`;
			const size = `400x400_crop_center`;
                        const src = variant.featured_media.preview_image.src;
                        const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
                        
                        if( match && label) {
                            //add the size to the image
                            const suffix = match[0];
                            const prefix = src.split(suffix);
                            const image = `${prefix[0]}_${size}${suffix}`;
                          
                            //set background image property
                            label.classList.add('swatch');
                            label.style.setProperty('background-image', `url(${image})`);
                            label.style.setProperty('background-size', '50px 50px');
                            label.style.setProperty('background-position', 'center');
                            label.style.setProperty('width', `${width}px`);
                            label.style.setProperty('min-width', `${width}px`);
                            label.style.setProperty('height', `${height}px`);
                            label.style.setProperty('min-height', `${height}px`); 
                            label.style.setProperty('border-radius', '100%');
                            label.style.setProperty('transition', 'none');
                            
                            
                        }                
                    }
                
                }
            }
        
        }
    }
	
    //the name of the color options
    const colorNames = ["QTY","Style", "Color", "Colour", "Color Mix", "Flannel Print","SPECIALTY MIX", "FLANNEL PRINT MIX", "Pattern", "Sponge Style", "Backing Color", "Chenille Color", "Print/Color", "Linen Color", "STRING BAG COLOR"];

    document.addEventListener("DOMContentLoaded", function(){
        const container = document.querySelectorAll('.product-section');
        container.forEach(function(productSection){
            const productJSON = productSection.querySelector("[data-product-json]");
            if (productJSON && productJSON.innerHTML !== '') {
                product = JSON.parse(productJSON.innerHTML);
            }            
            if(product != null && colorNames != null){
              colorNames.forEach(function(colorName){
                 init(colorName, product, productSection);
              });
            }
        });
    });
})();
  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

